/**
 * Reading progress arithmetic (omega-motion.js M-6, L108–125; docs/behavior/hero-and-motion.md §7.3).
 */

/** The bar exists only where the page is genuinely long. */
export const READING_PROGRESS_MIN_SCROLL = 2600;

export function scrollSpan(scrollHeight: number, innerHeight: number): number {
  return scrollHeight - innerHeight;
}

export function isLongEnough(span: number): boolean {
  return span > READING_PROGRESS_MIN_SCROLL;
}

/** Bar width as production wrote it: a clamped percentage string. */
export function progressWidth(scrollY: number, span: number): string {
  return Math.max(0, Math.min(100, (scrollY / span) * 100)) + '%';
}
